export default __webpack_public_path__ + "static/media/logo.9df07210.png";